module.exports = __webpack_public_path__ + "static/img/f6a7d4593525f1665c8d1736a40c1b87.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index_adv7.jpg
// module id = iHge
// module chunks = 1